import ApiService from '../services/ApiService';
import FileService from '../services/FileService';
import * as camelcaseKeys from 'camelcase-keys';

export default class NewsRepository {
    constructor() {
        this.apiService = new ApiService();
        this.fileService = new FileService();
    }

    createNews(data) {
        data = this.transformNewsDataForRequest(data);
        return new Promise((resolve, reject) => {
            this.apiService
                .post('news', data)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteNews(id) {
        return new Promise((resolve, reject) => {
            this.apiService
                .delete('news/' + id)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getNews(sort) {
        return new Promise((resolve, reject) => {
            this.apiService
                .get('news?no-pagination=true&sort=' + sort)
                .then(response => resolve(response.data))
                .catch(error => reject(error));
        });
    }

    getNewsById(id) {
        return new Promise((resolve, reject) => {
            this.apiService
                .get('news/' + id)
                .then(response =>
                    resolve(this.transformResponseToNews(response))
                )
                .catch(error => reject(error));
        });
    }

    transformNewsDataForRequest(data, method = null) {
        if (data.image) {
            data.image = this.fileService.convertBase64ToFIle(
                data.image,
                data.imageName
            );
        }

        if (data.video) {
            data.video = this.fileService.convertBase64ToFIle(
                data.video,
                data.videoName
            );
        }

        if (data.tags) {
            data.tags = JSON.stringify(data.tags);
        }

        return this.apiService.convertDataToFormData(data, method);
    }

    transformResponseToNews(news) {
        news = camelcaseKeys(news);
        news.imageUrl = news.image;
        news.videoUrl = news.video;

        return news;
    }

    updateNews(id, data) {
        data = this.transformNewsDataForRequest(data, 'PUT');

        return new Promise((resolve, reject) => {
            this.apiService
                .post('news/' + id, data)
                .then(response =>
                    resolve(this.transformResponseToNews(response))
                )
                .catch(error => reject(error));
        });
    }
}
